import { useContext, useEffect, useRef, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import { createSearchParams, useParams } from 'react-router-dom'
import InputText from '../../common/InputText'
import Button from '../../common/Button'
import {
  SET_SELECTED_WIRE_DATA,
  SET_SHOW_HIDE_WIRE_POPUP,
  SET_WIRE_DATA,
  WireContext,
} from './context/context'
import NoRecordsFound from '../../common/NoRecordsFound'
import WireRows from './WireRows'
import { deleteRequest, getRequest } from '../../../services/base'
import Pagination from '../../common/Pagination'
import WireFormModal from './form'
import LinkWithStatus from '../../common/LinkWithStatus'
import { getSessionStorageData } from '../../../utils/SessionStorage'

const Wire = () => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(NavContext)
  const [wireState, wireDispatch] = useContext(WireContext)
  const [searchValue, setSearchValue] = useState('')
  const currentUrl = useRef(`/api/wire/?vehicle=${vehicle}`)

  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / Wires`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
    getWiresData()
  }, [])

  const getWiresData = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Wire List Data...',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(currentUrl.current)
    wireDispatch({ type: SET_WIRE_DATA, data: res })
    dispatch({
      type: 'loader',
      data: {
        showLoader: false,
      },
      notification: {},
    })
  }

  const onWireDelete = async (wire_id) => {
    if (
      window.confirm(`Are you surem you want delete selected wire?`) === true
    ) {
      dispatch({
        type: 'loader',
        data: {
          caption: 'Delete Selected Wire Details...',
          showLoader: true,
        },
        notification: {},
      })
      let res = await deleteRequest(`/api/wire/${wire_id}/?vehicle=${vehicle}`)
      getWiresData()
    }
  }

  return (
    <div className="w-full">
      {wireState?.showWireFormPopup && (
        <WireFormModal
          onClose={() => {
            getWiresData()
            wireDispatch({
              type: SET_SHOW_HIDE_WIRE_POPUP,
              data: false,
            })
          }}
        />
      )}

      <form
        className="flex flex-col w-full space-y-2 pb-2"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div
          className={`flex space-x-5 justify-between content-center items-center`}
        >
          <div className="flex items-center w-1/2">
            <InputText
              name="search_value"
              placeholder={`Search Wires`}
              className={`w-100`}
              value={searchValue}
              isFullSize={true}
              type="search"
              onChange={(value) => {
                setSearchValue(value)
              }}
              isRequired={false}
            />
            <Button
              className={`cursor-pointer btn my-4 justify-end`}
              text={`Search`}
              onClick={() => {
                currentUrl.current = `/api/wire/?vehicle=${vehicle}&search=${searchValue}`
                getWiresData()
              }}
            />
          </div>
          <LinkWithStatus
            href={`/administration/system/new`}
            className={
              'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
            }
            title="Upload New File"
            onClickFunc={() => {
              wireDispatch({
                type: SET_SHOW_HIDE_WIRE_POPUP,
                data: true,
              })
            }}
          />
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-2/12 items-center">Harness</div>
          <div className="flex w-2/12 pl-6 items-center">Circuit</div>
          <div className="flex w-2/12 pl-6 items-center">Pin</div>
          <div className="flex w-4/12 pl-6 items-center">Connector</div>
          <div className="flex w-2/12 pl-6 items-center"></div>
        </div>
      </div>
      {wireState?.data?.results?.map((wire, index) => {
        return (
          <WireRows
            {...wire}
            key={`wire-row-${index}-${wire.id}`}
            onDelete={() => {
              onWireDelete(wire.id)
            }}
            onShowDetails={() => {
              wireDispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: wire,
              })
            }}
          />
        )
      })}

      {wireState?.data?.results?.length < 1 && (
        <NoRecordsFound caption={`Wire's not found`} loading={false} />
      )}
      {wireState.data.pagination && (
        <div className="py-6">
          <Pagination
            context={wireState.data.pagination}
            onClickNext={(e) => {
              currentUrl.current = e
              getWiresData()
            }}
            onClickPrev={(e) => {
              currentUrl.current = e
              getWiresData()
            }}
          />
        </div>
      )}
    </div>
  )
}

export default Wire
